import React, {FC, useState} from 'react';
import {
  Container,
  TitleWrapper,
  HeadCardContainer,
  Datetext,
  AttachmentsWrapper,
  AttachmentContainer,
  AttachmentImg,
  AttachmentTitleWrapper,
  AttachmentTitleRow,
  AttachmentName,
  AttachmentSize,
  Attachments,
  DivMessage
} from './styles'
import Gravatar from 'react-gravatar'
import { Typography, PrevImage } from '../../../../../components';
import { useTheme } from 'styled-components';
import moment from 'moment'
import { useTranslation } from 'react-i18next';
import { icons } from '../../../../../icons';
import StyledIcon from '../../../../../components/styled-icon'
import { formatFileSize } from '../../../../../utils/sizes';
type MessageProps = {
  message: string,
  email?: string,
  displayName: string,
  time: any,
  active?: boolean,
  attachments:any[],
}

const linkifyMessage = (message: string) => {
  if (!message || typeof window === 'undefined') {
    return message
  }

  const urlRegex = /(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi
  const wrapper = document.createElement('div')
  wrapper.innerHTML = message
  const walker = document.createTreeWalker(wrapper, NodeFilter.SHOW_TEXT)
  const textNodes: Text[] = []

  while (walker.nextNode()) {
    const node = walker.currentNode as Text

    if (node.parentElement?.closest('a')) {
      continue
    }

    textNodes.push(node)
  }

  textNodes.forEach((node) => {
    if (!urlRegex.test(node.nodeValue || '')) {
      return
    }

    urlRegex.lastIndex = 0
    const fragment = document.createDocumentFragment()
    let lastIndex = 0

    ;(node.nodeValue || '').replace(urlRegex, (url, _match, offset) => {
      fragment.append(document.createTextNode((node.nodeValue || '').slice(lastIndex, offset)))

      const link = document.createElement('a')
      link.href = url.startsWith('www.') ? `https://${url}` : url
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
      link.textContent = url
      fragment.append(link)
      lastIndex = offset + url.length

      return url
    })

    fragment.append(document.createTextNode((node.nodeValue || '').slice(lastIndex)))
    node.parentNode?.replaceChild(fragment, node)
  })

  return wrapper.innerHTML
}

const TicketMessageComponent:FC<MessageProps> = (props) => {
  const {
    message,
    email,
    displayName,
    time,
    active,
    attachments
  } = props
  const theme:any = useTheme()
  const [t] = useTranslation()
  return(
    <Container active={active}>
      <HeadCardContainer>
        <Gravatar
          email={email}
          size={40}
          style={{borderRadius: '100%'}}
        />
        <TitleWrapper>
          <Typography variant='body-medium'>
            {displayName}
          </Typography>
          <Datetext>
            {moment(time * 1000).fromNow()}
          </Datetext>
        </TitleWrapper>
      </HeadCardContainer>
      <DivMessage dangerouslySetInnerHTML={{__html:linkifyMessage(message)}}/>
      {attachments?.length > 0 && 
        <Attachments>
          <Typography variant='h3'>{t("ATTACHMENTS")}</Typography>
          <AttachmentsWrapper>
            {attachments.map((attachment:any) => (
              <AttachmentComponent
                key={attachment.id ?? attachment.original_name}
                size={attachment.upload.size}
                name={attachment.original_name}
                url={attachment.direct_frontend_url}
              />
            ))}
          </AttachmentsWrapper>
        </Attachments>
      }
    </Container>
  )
}

export default TicketMessageComponent

export const AttachmentComponent:FC<any> = (props) => {
  const {
    size,
    name,
    url,
    isUpload,
    handleDelete,
  } = props
  const [viewImage, setViewImage] = useState<boolean>(false)
  const [imageFailed, setImageFailed] = useState<boolean>(false)
  const isImage = /\.(png|jpe?g|svg|gif|webp)$/i.test(name || '')
  const canPreviewImage = isImage && Boolean(url) && !imageFailed
  return (
    <AttachmentContainer style={isUpload ? {alignItems:"flex-start"} : {}}>
      {/* <img src={`https://support.onepointcollab.com/en/admin/ticket/attachment/${attachment.upload.hash}/preview`}/> */}
      <AttachmentTitleWrapper onClick={() => canPreviewImage && setViewImage(true)}>
        <AttachmentImg
          $placeholder={!canPreviewImage}
          alt={name || ''}
          src={canPreviewImage ? url : icons.Document}
          onError={() => {
            setImageFailed(true)
            setViewImage(false)
          }}
        />
        <AttachmentTitleRow>
          <AttachmentName>
            {name}
          </AttachmentName>
          <AttachmentSize>
            {isUpload ? formatFileSize(size) : size}
          </AttachmentSize>
        </AttachmentTitleRow>
      </AttachmentTitleWrapper>
      {isUpload ? 
        <StyledIcon onClick={() => {
            // window.location.href = url
            handleDelete(name)
          }} active={false} src={icons.CloseIconBold}
        />
          :
        <StyledIcon onClick={() => {
            window.location.href = url
          }} active={false} src={icons.IcDownload}
        />
      }
      {canPreviewImage ?
        <PrevImage handleClose={() => {
          setViewImage(false)}} activeProp={viewImage} url={url}
        />
      : null}
    </AttachmentContainer>
  )
}
